/**
 * Проверяет, истекла ли игра по дате отключения
 */
export const isGameExpired = (activateDate: Date | string | null, gameDayCount: number): boolean => {
  if (!activateDate || !gameDayCount) {
    return false;
  }
  
  // Конвертируем activateDate в объект Date, если это строка
  const activateDateObj = typeof activateDate === 'string' ? new Date(activateDate) : activateDate;
  
  const endDate = new Date(activateDateObj.getTime() + gameDayCount * 24 * 60 * 60 * 1000);
  const currentDate = new Date();
  
  return currentDate > endDate;
};

/**
 * Получает дату отключения игры
 */
export const getGameEndDate = (activateDate: Date | string | null, gameDayCount: number): Date | null => {
  if (!activateDate || !gameDayCount) {
    return null;
  }
  
  // Конвертируем activateDate в объект Date, если это строка
  const activateDateObj = typeof activateDate === 'string' ? new Date(activateDate) : activateDate;
  
  return new Date(activateDateObj.getTime() + gameDayCount * 24 * 60 * 60 * 1000);
};

/**
 * Форматирует дату отключения для отображения
 */
export const formatGameEndDate = (activateDate: Date | string | null, gameDayCount: number): string => {
  const endDate = getGameEndDate(activateDate, gameDayCount);
  
  if (!endDate) {
    return '-';
  }
  
  return endDate.toLocaleDateString('ru-RU');
};

import dayjs from 'dayjs';

export const getEndEditDate = (
  activateDate: Date | null,
  editDayCount: number
) => dayjs(activateDate).add(editDayCount, 'day').format('DD/MM/YYYY HH:mm:ss');

export const getEndGameDateFormatted = (
  activateDate: Date | null,
  gameDayCount: number
) => dayjs(activateDate).add(gameDayCount, 'day').format('DD/MM/YYYY HH:mm:ss'); 